<template>
  <div class="r-text-body-small">
    <div class="question">איך נוח לך לקבל מ׳מיטב׳ מסמכים רשמיים?</div>
    <div class="row justify-between">
      <rich-radio-button
        label="דוא״ל (מייל)"
        :value="MailingChannel.EMAIL"
        :selected-value="mailingChannel"
        icon="email"
        v-on="$listeners" />
      <rich-radio-button
        :value="MailingChannel.SMS"
        :selected-value="mailingChannel"
        label="הודעת מסרון (SMS)"
        icon="chat"
        v-on="$listeners" >
      </rich-radio-button>
      <rich-radio-button
        label="דואר ישראל"
        :value="MailingChannel.MAIL"
        :selected-value="mailingChannel"
        icon="markunread_mailbox"
        v-on="$listeners" />
    </div>
  </div>
</template>

<script>
import RichRadioButton from '@/components/styled/RichRadioButton';
import { MailingChannel } from '@/constants/meitav-dash/open-fund';

export default {
  name: 'SelectMailingChannel',
  components: { RichRadioButton },
  props: {
    mailingChannel: String,
  },
  computed: {
    MailingChannel() {
      return MailingChannel;
    },
  },
};
</script>

<style lang="scss" scoped>
.question {
  margin-bottom: 8px;
}
</style>
